<template>
    <div class="container">
        <div v-if="loadingPrint" class="print-spin">
            <a-spin tip="打印生成中..." />
        </div>
        <a-card title="查看流程详情" size="small">
            <template slot="extra">
                <a-button v-if="fillStatus == 3" @click="print" :style="{ marginRight: '8px' }">
                    打印
                </a-button>
                <a-button @click="showProcessDiagram = true" :style="{ marginRight: '8px' }">流程跟踪</a-button>
                <a-button @click="goBack">返回</a-button>
            </template>
            <a-form-model ref="addForm" :model="formObject" :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }"
                style="position: relative">
                <div style="
                        position: absolute;
                        right: -12px;
                        top: -12px;
                        z-index: 2;
                        height: calc(100vh - 160px);
                    ">
                    <div class="sliderbar-off" @click="clickChange">
                        <a-icon :type="sliderbar ? 'double-right' : 'double-left'" />
                        流转记录
                    </div>
                    <div :class="!sliderbar ? 'right-close' : 'right-open'" v-show="sliderbarShow">
                        <div style="
                                background: #fff;
                                width: 100%;
                                height: 100%;
                                border-left: 1px solid #e6e6e6;
                                border-top: 1px solid #e6e6e6;
                            ">
                            <!-- 标签页切换 -->
                            <div class="tab-header">
                                <div class="tab-item" :class="{ active: currentTab === 'flow' }"
                                    @click="switchTab('flow')">
                                    流转记录
                                </div>
                                <div class="tab-item" :class="{ active: currentTab === 'form' }"
                                    @click="switchTab('form')">
                                    关联表单
                                </div>
                            </div>

                            <!-- 流转记录内容 -->
                            <div v-if="currentTab === 'flow'" class="tab-content">
                                <a-card :bordered="false" title="审批记录" size="small">
                                    <div class="flow">
                                        <a-timeline>
                                            <a-timeline-item v-for="(item, index) in mergedFlowList" :key="index"
                                                :color="getCircleColor(item)">
                                                <p>{{ `${item.taskName}` }}</p>
                                                <el-card :body-style="{ padding: '10px' }">
                                                    <!-- 普通节点展示 -->
                                                    <div v-if="!item.multiInstance" class="div-class">
                                                        <label v-if="item.assigneeName" style="
                                                                font-weight: normal;
                                                                margin-right: 30px;
                                                                display: flex;
                                                                align-items: center;
                                                            ">
                                                            <div style="margin-right: 5px">
                                                                实际办理： {{ item.assigneeName }}
                                                            </div>
                                                            <el-popover trigger="hover" placement="top">
                                                                <p>{{ item.deptName }}</p>
                                                                <template slot="reference" class="name-wrapper">
                                                                    <el-tag type="info" size="mini" style="
                                                                            cursor: pointer;
                                                                            max-width: 200px;
                                                                            overflow: hidden;
                                                                            white-space: nowrap;
                                                                            text-overflow: ellipsis;
                                                                        ">
                                                                        {{ item.deptName }}
                                                                    </el-tag>
                                                                </template>
                                                            </el-popover>
                                                        </label>
                                                        <template v-if="index == 0">
                                                            <div>
                                                                <label style="
                                                                        color: #8a909c;
                                                                        font-weight: normal;
                                                                    ">
                                                                    申请时间：
                                                                    {{ item.finishTime }}
                                                                </label>
                                                            </div>
                                                        </template>
                                                        <template v-if="index != 0">
                                                            <div>
                                                                <label style="font-weight: normal">
                                                                    接收时间：
                                                                </label>
                                                                <label style="
                                                                        color: #8a909c;
                                                                        font-weight: normal;
                                                                    ">
                                                                    {{ item.createTime }}
                                                                </label>
                                                            </div>
                                                            <div>
                                                                <label v-if="item.finishTime" style="
                                                                        margin-left: 0px;
                                                                        font-weight: normal;
                                                                    ">
                                                                    办结时间：
                                                                </label>
                                                                <label style="
                                                                        color: #8a909c;
                                                                        font-weight: normal;
                                                                    ">
                                                                    {{ item.finishTime }}
                                                                </label>
                                                            </div>
                                                            <!-- 最后一个节点（待处理）展示 -->
                                                            <div v-if="
                                                                index === mergedFlowList.length - 1 &&
                                                                item.comment === null
                                                            ">
                                                                <div>
                                                                    <label style="
                                                                            font-weight: normal;
                                                                            margin-right: 30px;
                                                                            display: block;
                                                                        ">
                                                                        <div style="margin-right: 5px" v-if="currCheck.comment">
                                                                            实际办理：
                                                                            {{ currCheck.userName }}
                                                                        </div>
                                                                        <div style="margin-right: 5px;float: left;" v-else>
                                                                            等待办理：
                                                                        </div>
                                                                        <div style="display: flex;flex-wrap: wrap;">
                                                                            <el-tag
                                                                                v-for="(organItem, organIndex) in item.organPosList"
                                                                                :key="organIndex" type="info"
                                                                                size="mini"
                                                                                style="cursor: pointer;max-width: 300px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin: 0 5px 10px 0;">
                                                                                <p v-if="!organItem.userId && organItem.organId">
                                                                                    {{ organItem.organName + '/' +
                                                                                    organItem.postName}}
                                                                                </p>
                                                                                <p v-else-if="organItem.userId && !organItem.organId">
                                                                                    {{ organItem.userName }}
                                                                                </p>
                                                                                <p v-else-if="organItem.userId && organItem.organId">
                                                                                    {{ organItem.userName + '(' +
                                                                                    organItem.organName + '/' +
                                                                                    organItem.postName + ')' }}
                                                                                </p>
                                                                            </el-tag>
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                                <div>
                                                                    <label v-if="item.taskName == '填写申请'">
                                                                        <a-tag class="tag-border-blue">
                                                                            申请提交
                                                                        </a-tag>
                                                                    </label>
                                                                    <label v-else>
                                                                        审核状态：
                                                                        <a-tag class="tag-border-blue">
                                                                            待　审
                                                                        </a-tag>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <div v-if="item.comment != undefined">
                                                            <label v-if="index != 0">
                                                                审核状态：
                                                                <a-tag v-if="item.comment.type == 1"
                                                                    class="tag-border-green">
                                                                    通　过
                                                                </a-tag>
                                                                <a-tag
                                                                    v-if="item.comment.type == 3 || item.comment.type == 2"
                                                                    class="tag-border-orange">
                                                                    驳　回
                                                                </a-tag>
                                                                <a-tag v-if="item.comment.type == 6"
                                                                    class="tag-border-red">
                                                                    不通过
                                                                </a-tag>
                                                            </label>
                                                            <br v-if="index != 0" />
                                                            <label v-if="index != 0" class="noline">
                                                                审核意见：
                                                                <el-popover trigger="hover" placement="top">
                                                                    <p>{{ item.comment.comment }}</p>
                                                                    <template slot="reference" class="name-wrapper">
                                                                        <span style="
                                                                                cursor: pointer;
                                                                                color: #8a909c;
                                                                                font-weight: normal;
                                                                            ">
                                                                            {{ item.comment.comment }}
                                                                        </span>
                                                                    </template>
                                                                </el-popover>
                                                            </label>
                                                        </div>

                                                        <!-- 自定义审批标签 -->
                                                        <template v-if="item.flowCustomLabelList">
                                                            <template v-for="(fitem, findex) in item.flowCustomLabelList">
                                                                <template v-if="item.taskId == fitem.taskId">
                                                                    <hr style="
                                                                            height: 1px;
                                                                            border: none;
                                                                            background-color: rgba(0,0,0,0.15);
                                                                        " v-if="findex == 0" />
                                                                    <template v-if="fitem.inputType != 'img'">
                                                                        <div>
                                                                            <label class="label-font">
                                                                                {{ fitem.inputKey }}：
                                                                            </label>
                                                                            <label style="
                                                                                    color: #8a909c;
                                                                                    font-weight: normal;
                                                                                    white-space: normal;
                                                                                ">
                                                                                {{ fitem.inputValue }}
                                                                            </label>
                                                                        </div>
                                                                    </template>
                                                                    <template v-if="fitem.inputType == 'img'">
                                                                        <div>
                                                                            <label class="label-font">
                                                                                {{ fitem.inputKey }}：
                                                                            </label>
                                                                            <label>
                                                                                <img :src="fitem.inputValue" alt="签名图片"
                                                                                    style="width: 4.95rem; height: 4.95rem;" />
                                                                            </label>
                                                                        </div>
                                                                    </template>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </div>

                                                    <!-- 会签节点展示 -->
                                                    <div v-else class="multi-instance-group">
                                                        <div class="group-header">
                                                            <span>会签（共 {{ item.subTasks.length }} 人）</span>
                                                            <a-button type="link" size="small"
                                                                @click="toggleGroupExpand(item)">
                                                                {{ item.expanded ? '收起详情' : '查看详情' }}
                                                            </a-button>
                                                        </div>
                                                        <div v-if="item.expanded" class="group-detail">
                                                            <div v-for="(sub, idx) in item.subTasks" :key="sub.taskId"
                                                                class="sub-task">
                                                                <div>办理人：{{ sub.assigneeName || sub.assigneeId }}</div>
                                                                <div>审核意见：{{ sub.comment?.comment || '无' }}</div>
                                                                <div>办理时间：{{ sub.finishTime || sub.createTime }}</div>
                                                                <div>办理结果：
                                                                    <a-tag v-if="sub.comment?.type == 1" class="tag-border-green">通过</a-tag>
                                                                    <a-tag v-if="sub.comment?.type == 3 || sub.comment?.type == 2"
                                                                        class="tag-border-orange">驳回</a-tag>
                                                                    <a-tag v-if="sub.comment?.type == 6" class="tag-border-red">不通过</a-tag>
                                                                    <span v-else>-</span>
                                                                </div>
                                                                <hr v-if="idx !== item.subTasks.length - 1" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </el-card>
                                            </a-timeline-item>
                                        </a-timeline>
                                    </div>
                                </a-card>
                                <a-card v-if="taskObject != null" :bordered="false" title="任务分配记录" size="small">
                                    <div class="flow">
                                        <a-timeline>
                                            <a-timeline-item :color="getCircleColor(taskObject)">
                                                <el-card :body-style="{ padding: '10px' }">
                                                    <div class="div-class">
                                                        <label style="
                                                            font-weight: normal;
                                                            margin-right: 30px;
                                                            display: flex;
                                                            align-items: center;
                                                            ">
                                                            <div style="margin-right: 5px">
                                                                任务人：{{ taskObject.username || '未分配' }}
                                                            </div>
                                                        </label>
                                                        <div>
                                                            <label>
                                                                任务状态：
                                                                <a-tag v-if="taskObject.status == 0" class="tag-border-orange">
                                                                    待　办
                                                                </a-tag>
                                                                <a-tag v-if="taskObject.status == 1" class="tag-border-green">
                                                                    已　办
                                                                </a-tag>
                                                                <a-tag v-if="taskObject.status == null || !taskObject.status"
                                                                    class="tag-border-blue">
                                                                    待分配
                                                                </a-tag>
                                                            </label>
                                                            <br />
                                                        </div>
                                                        <div>
                                                            <label style="font-weight: normal">操作人：</label>
                                                            <label style="color: #8a909c; font-weight: normal">
                                                                {{ taskObject.createUserName || '未知操作人' }}
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <label style="margin-left: 0px; font-weight: normal">创建时间：</label>
                                                            <label style="color: #8a909c; font-weight: normal">
                                                                {{ taskObject.createtime || taskObject.createtime || '无' }}
                                                            </label>
                                                            <label class="noline" v-if="taskObject.status == '1'">
                                                                办结意见：
                                                                <el-popover trigger="hover" placement="top">
                                                                    <template slot="reference" class="name-wrapper">
                                                                        <span style="cursor: pointer; color: #8a909c; font-weight: normal">
                                                                            {{ taskObject.opinion || '未填写' }}
                                                                        </span>
                                                                    </template>
                                                                </el-popover>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </el-card>
                                            </a-timeline-item>
                                        </a-timeline>
                                    </div>
                                </a-card>
                            </div>
                            <!-- 关联表单内容 -->
                            <div v-else class="tab-content">
                                <a-card :bordered="false" title="关联表单" size="small">
                                    <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
                                        <a-button type="primary" size="small" @click="addRelatedForm">新增</a-button>
                                    </div>
                                    <a-table :row-key="record => record.id" :data-source="CorrelationFormList"
                                        :columns="relatedFormColumns" :pagination="false" :loading="viewLoading"
                                        size="small">
                                        <template slot="statusType" slot-scope="text, record">
                                            <a-tag :color="fillStatusColorList.find(item => item.itemKey == record.fillStatus).itemName">
                                                {{ fillStatusList.find(item => item.itemKey == record.fillStatus)?.itemName || '未知状态' }}
                                            </a-tag>
                                        </template>
                                        <template slot="operation" slot-scope="text, record">
                                            <a-button type="link" @click="() => onViewWaitMeApply(record)">
                                                查看
                                            </a-button>
                                        </template>
                                    </a-table>
                                </a-card>
                            </div>
                        </div>
                    </div>
                </div>
                <a-row>
                    <a-col :span="13">
                        <a-form-model-item label="所属组织及岗位" prop="organPostId">
                            <a-cascader v-model.trim="formObject.organPostId" :options="options" disabled
                                placeholder="请选择所属组织及岗位" :style="{ width: '100%', textAlign: 'left' }"
                                :getPopupContainer="triggerNode => triggerNode.parentNode" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="4"></a-col>
                    <span style="font-size: 16px;font-weight: bold;display: inline-block;margin-top: 12px;">申请流水号：{{ needId }}</span>
                    <img src="@/assets/img/tongguo.png" alt="" :class="sliderbar ? 'zIndex-img' : 'img'" v-if="fillStatus == 3" />
                </a-row>
            </a-form-model>
        </a-card>
        <div class="process-view-container">
            <a-card :bordered="false" class="left-card disabled-cursor">
                <fm-generate-form :data="formData" :value="fillData" ref="generateForm" :edit="false"></fm-generate-form>
            </a-card>
            <a-drawer :width="500" :closable="true" :visible="editVisible" @close="onEditClose" destroyOnClose
                :zIndex="999" maskClosable></a-drawer>
        </div>
        <div id="printTable" style="display: none">
            <iframe :src="printSrc" seamless id="printFrame" style="width: 100%; height: calc(70vh)"></iframe>
        </div>
        <a-modal title="新增关联表单" :visible="modalVisible" @ok="saveRelatedForm" @cancel="modalVisible = false" okText="确定"
            cancelText="取消">
            <a-form-model ref="addForm" :model="newFormRecord" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }"
                :rules="{ formneedId: [{ required: true, message: '请选择关联的表单', trigger: 'change' }] }">
                <a-form-model-item label="关联表单" prop="formneedId">
                    <a-select v-model="newFormRecord.formneedId" placeholder="请输入流水号检索" show-search
                        @search="handleSearch" optionFilterProp="children" :debounce="300">
                        <a-select-option v-for="item in filteredFormList" :key="item.id" :value="item.id"
                            :label="`${item.formName}(${item.id})`">
                            {{ item.formName + '(' + item.id + ')' }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <!-- 流程图弹窗 -->
        <a-modal :visible="showProcessDiagram" :width="isFullscreen ? '100%' : '900px'" :footer="null" :destroyOnClose="true"
            :closable="false" :zIndex="99999" :wrapClassName="isFullscreen ? 'fullscreen-modal' : ''"
            @cancel="closeDiagramModal">
            <template slot="title">
                <span>审批流程图</span>
                <div class="modal-title-icons">
                    <a-icon :type="isFullscreen ? 'fullscreen-exit' : 'fullscreen'" @click="toggleFullscreen" />
                    <a-icon type="close" @click="closeDiagramModal" />
                </div>
            </template>
            <div class="process-modal-body" :class="{ 'fullscreen-body': isFullscreen }">
                <ProcessTracker v-if="showProcessDiagram" :process-instance-id="procInsId" />
            </div>
        </a-modal>
    </div>
</template>

<script>
import {
    queryMyApplyFormList,
    saveCorrelationForm,
    queryCorrelationFormList,
    getFormTask
} from '@/services/myApply';
import {
    getFlowRecordById,
    queryFormFillByProcInsId,
    readXml,
    formPrintById,
    getFlowViewer,
    printFormTemplate,
    getOrganPostTreeByOrganId
} from '@/services/form';
import axios from 'axios';
import { slice } from 'lodash';
import { id } from 'date-fns/locale';
import ProcessTracker from '@/pages/components/ProcessTracker.vue';

export default {
    components: {
        ProcessTracker,
    },
    name: 'ViewProcess',
    data() {
        return {
            taskObject: null,
            viewLoading: false,
            formApplayList: [],
            CorrelationFormList: [],
            filteredFormList: [],
            modalVisible: false,
            newFormRecord: {
                formName: '',
                formneedId: '',
                id: ''
            },
            sliderbarShow: false,
            sliderbar: false,
            currentTab: 'flow',
            formObject: {
                organPostId: []
            },
            printFlag: false,
            editVisible: false,
            procInsId: '',
            rawFlowList: [],      // 原始流转记录（未合并）
            mergedFlowList: [],   // 合并后的展示列表
            flowFromData: {},
            formData: {
                list: [],
                config: {
                    labelWidth: 100,
                    labelPosition: 'right',
                    size: 'small',
                    customClass: '',
                    ui: 'element',
                    layout: 'horizontal',
                    labelCol: 3,
                    width: '100%',
                    hideLabel: false,
                    hideErrorMessage: false
                }
            },
            fillData: {},
            options: [],
            userInfo: this.$hdk.userInfo.get(),
            path: '',
            currCheck: {
                comment: '',
                userName: '',
                deptName: ''
            },
            fillStatus: '',
            loadingPrint: false,
            printSrc: '',
            formId: '',
            needId: '',
            versionId: '',
            fillStatusList: [
                { itemName: '草　稿', itemKey: 0 },
                { itemName: '待审批', itemKey: 1 },
                { itemName: '审批中', itemKey: 2 },
                { itemName: '通　过', itemKey: 3 },
                { itemName: '驳　回', itemKey: 4 },
                { itemName: '作　废', itemKey: 5 },
                { itemName: '不通过', itemKey: 6 },
                { itemName: '挂　起', itemKey: 7 }
            ],
            fillStatusColorList: [
                { itemName: '#bfbfbf', itemKey: 0 },
                { itemName: 'rgb(24, 144, 255)', itemKey: 1 },
                { itemName: '#1890ff', itemKey: 2 },
                { itemName: 'rgb(79, 191, 73)', itemKey: 3 },
                { itemName: '#ff9806', itemKey: 4 },
                { itemName: '#d6dce5', itemKey: 5 },
                { itemName: 'rgb(220, 33, 39)', itemKey: 6 },
                { itemName: '#999999', itemKey: 7 }
            ],
            relatedForms: [],
            relatedFormColumns: [
                { title: '表单名称', dataIndex: 'formName', key: 'formName', width: 50 },
                { title: '流水号', dataIndex: 'id', key: 'id', width: 50 },
                { title: '办理状态', dataIndex: 'fillStatus', width: 50, scopedSlots: { customRender: 'statusType' } },
                { title: '操作', width: 50, scopedSlots: { customRender: 'operation' } }
            ],
            showProcessDiagram: false,
            isFullscreen: false,
        };
    },
    methods: {
        // 合并会签子任务
        mergeMultiInstanceTasks(flowList) {
            const groupMap = new Map();
            const normalList = [];
            flowList.forEach(item => {
                if (item.multiInstance && item.multiInstanceGroupId) {
                    const groupId = item.multiInstanceGroupId;
                    if (!groupMap.has(groupId)) {
                        const group = {
                            ...item,
                            subTasks: [],
                            multiInstance: true,
                            assigneeName: undefined,
                            comment: undefined,
                            expanded: false
                        };
                        groupMap.set(groupId, group);
                    }
                    const group = groupMap.get(groupId);
                    group.subTasks.push(item);
                    // 更新组的创建时间（取最早）
                    if (!group.createTime || (item.createTime && item.createTime < group.createTime)) {
                        group.createTime = item.createTime;
                    }
                    // 更新组的完成时间（取最晚）
                    if (!group.finishTime || (item.finishTime && item.finishTime > group.finishTime)) {
                        group.finishTime = item.finishTime;
                    }
                } else {
                    normalList.push(item);
                }
            });
            const groupList = Array.from(groupMap.values());
            // 按创建时间排序（升序）
            const allItems = [...normalList, ...groupList];
            allItems.sort((a, b) => new Date(a.createTime) - new Date(b.createTime));
            return allItems;
        },
        // 切换会签组展开/收起
        toggleGroupExpand(item) {
            this.$set(item, 'expanded', !item.expanded);
        },
        // 获取圆点颜色（普通节点或会签组）
        getCircleColor(item) {
            let col;
            if (item.multiInstance && item.subTasks && item.subTasks.length) {
                // 会签组：取组内第一个子任务的颜色
                col = this.getTagColor(item.subTasks[0]?.comment?.type);
            } else {
                col = this.getTagColor(item.comment?.type);
            }
            if (col == undefined) col = this.getTagColor('0');
            return col;
        },
        getTagColor(type) {
            let colors = [
                { itemVal: 'rgba(255, 152, 6, 0.8)', itemKey: '3' },
                { itemVal: 'rgba(255, 152, 6, 0.8)', itemKey: '2' },
                { itemVal: 'rgba(79, 191, 73, 0.8)', itemKey: '1' },
                { itemVal: 'rgba(220, 33, 39, 0.8)', itemKey: '6' },
                { itemVal: 'rgba(24, 144, 255, 0.8)', itemKey: '0' }
            ];
            return colors.find(item => item.itemKey == type)?.itemVal;
        },
        getTagMsg(type) {
            let msg = [
                { itemVal: '驳回', itemKey: '3' },
                { itemVal: '通过', itemKey: '1' },
                { itemVal: '不通过', itemKey: '6' }
            ];
            return msg.find(item => item.itemKey == type)?.itemVal;
        },
        formartDept(dept) {
            if (dept) {
                let depts = dept.split(',');
                if (depts.length > 1) {
                    return depts[0] + '...';
                } else {
                    return dept;
                }
            }
        },
        clickChange() {
            this.sliderbar = !this.sliderbar;
            this.sliderbarShow = true;
        },
        switchTab(tab) {
            this.currentTab = tab;
        },
        addRelatedForm() {
            this.newFormRecord = { formName: '', formneedId: '', id: '' };
            this.modalVisible = true;
        },
        saveRelatedForm() {
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    const param = {
                        formneedId: this.newFormRecord.formneedId,
                        needId: this.needId
                    };
                    if (this.newFormRecord.formneedId == this.needId) {
                        this.$message.warning('表单不能关联自身，请选择其他表单继续操作!');
                    } else {
                        saveCorrelationForm(param).then(res => {
                            if (res.data.code == 200) {
                                this.modalVisible = false;
                                this.queryCorrelationFormList();
                            }
                        });
                    }
                } else {
                    console.log('表单校验失败!');
                }
            });
        },
        async onViewWaitMeApply(record) {
            try {
                this.viewLoading = true;
    

                const targetPath = '/formReview/reviewCenter/viewProcess';
                if (this.$route.path !== targetPath) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                                this.$router.push({
                                    path: '/formReview/reviewCenter/viewProcess',
                                    query: {
                                        procInsId: record.processInstanceId,
                                        fillId: record.id,
                                        fillStatus: record.fillStatus
                                    }
                                });
                }else{
                this.procInsId = record.processInstanceId,
                        this.fillId = record.id,
                        this.fillStatus =  record.fillStatus
                        if (this.fillStatus == 3) this.printFlag = true;
                
                        this.queryOrganPost();
                        await this.onloadFlowRecord();
                }

              


            } catch (error) {
                this.$message.error('查看表单失败，请重试');
                console.error('查看表单错误：', error);
            } finally {
                this.viewLoading = false;
            }
        },
        onOrganAndJob(value) {
            const { $set, formObject } = this;
            $set(formObject, 'organId', value[0]);
            $set(formObject, 'postId', value[1]);
            this.formObject.customize = {};
            this.formObject.customize.organId = value[0];
            this.formObject.customize.postId = value[1];
        },
        editVisibleShow() {
            this.editVisible = true;
        },
        onEditClose() {
            this.editVisible = false;
        },
        goBack() {
            if (this.path == 'waitdo') {
                this.$router.push({ path: '/dashboard/waitdo' });
            } else if (this.path == 'waitMeApplication') {
                this.$router.push({ path: '/formReview/reviewCenter/waitMeApplication' });
            } else {
                this.$router.go(-1);
            }
        },
        print() {
            this.loadingPrint = true;
            formPrintById({ procInsId: this.procInsId, templateId: this.formId, versionId: this.versionId }).then(res => {
                if (res.data.data) {
                    // this.printSrc = "/"+ res.data.data;
                    this.printSrc = res.data.data; 
                    console.log( this.printSrc )
                    const frame = document.getElementById('printFrame');
                    setTimeout(() => {
                        frame.contentWindow.print();
                        this.loadingPrint = false;
                    }, 200);
                } else {
                    this.loadingPrint = false;
                }
            });
        },
        onloadFlowRecord() {
            getFlowRecordById(this.procInsId).then(res => {
                if (res.data.code == 200) {
                    this.rawFlowList = res.data.data.flowList || [];
                    // 合并会签子任务
                    this.mergedFlowList = this.mergeMultiInstanceTasks(this.rawFlowList);
                    this.getOrganPostTreeByOrganId();   // 依赖 rawFlowList[0].deptId
                    this.queryMyApplyFormList();
                    this.queryCorrelationFormList();
                    this.getFormTask();
                    if (this.rawFlowList.length > 0) {
                        let flowObj = this.rawFlowList[this.rawFlowList.length - 1];
                        this.flowFromData = flowObj.formDta;
                        if (Object.prototype.hasOwnProperty.call(flowObj.formDta, 'formData')) {
                            let formDataJson = JSON.parse(flowObj.formDta.formData);
                            this.$set(this.formData, 'list', formDataJson.list);
                            this.$set(this.formData, 'config', formDataJson.config);
                            this.$refs.generateForm.refresh();
                            this.$refs.generateForm.setData(this.fillData);
                        }
                        if (typeof flowObj !== undefined && flowObj !== null) {
                            if (typeof flowObj.deptId !== undefined && flowObj.deptId !== null) {
                                let deptIdArr = flowObj.deptId.split(':');
                                if (deptIdArr && deptIdArr.length > 1 && deptIdArr[1] != 'null') {
                                    this.setCurrCheck(Number(deptIdArr[0]), Number(deptIdArr[1]), flowObj.comment);
                                }
                            } else {
                                queryFormFillByProcInsId({ procInsId: this.procInsId }).then(res => {
                                    if (res.data.code == 200) {
                                        this.setCurrCheck(Number(res.data.data.organId), Number(res.data.data.postId), flowObj.comment);
                                    }
                                });
                            }
                        }
                    }
                }
            });
        },
        queryOrganPost() {
            queryFormFillByProcInsId({ procInsId: this.procInsId }).then(res => {
                if (res.data.code == 200) {
                    this.formId = res.data.data.formId;
                    this.needId = res.data.data.id;
                    this.versionId = res.data.data.versionId;
                    this.fillStatus = res.data.data.fillStatus;
                    let fillDataJson = typeof res.data.data.fillData == 'string' ? JSON.parse(res.data.data.fillData) : res.data.data.fillData;
                    this.fillData = fillDataJson;
                    this.formObject.organPostId[0] = Number(res.data.data.organId);
                    this.formObject.organPostId[1] = Number(res.data.data.postId);
                }
            });
        },
        setCurrCheck(organId, postId, comment) {
            this.currCheck.userName = this.userInfo.userName;
            this.currCheck.comment = comment;
            let d1 = '', d2 = '';
            _.map(this.userInfo.organPostTree, item => {
                _.map(item.postList, subItem => {
                    if (subItem.postId === Number(postId)) d2 = subItem.postName;
                });
                if (item.organId === Number(organId)) d1 = item.organName;
            });
            this.currCheck.deptName = d1 + '/' + d2;
        },
        getOrganPostTreeByOrganId() {
            if (this.rawFlowList.length === 0) return;
            getOrganPostTreeByOrganId({ organId: this.rawFlowList[0].deptId.split(':')[0] }).then(res => {
                this.options = _.map(res.data.data, item => {
                    item.postList = _.map(item.postList, subItem => {
                        return { label: subItem.postName, value: subItem.postId, children: null };
                    });
                    return { label: item.organName, value: item.organId, children: item.postList };
                });
            });
        },
        async queryMyApplyFormList() {
            queryMyApplyFormList({}).then(res => {
                this.formApplayList = res.data.data || [];
            });
        },
        async queryCorrelationFormList() {
            queryCorrelationFormList({ needId: this.needId }).then(res => {
                this.CorrelationFormList = res.data.data || [];
            });
        },
        async getFormTask() {
            getFormTask({ needId: this.needId }).then(res => {
                this.taskObject = res.data.data;
            });
        },
        closeDiagramModal() {
            this.showProcessDiagram = false;
            this.isFullscreen = false;
        },
        toggleFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        handleSearch(inputValue) {
            if (!inputValue) {
                this.filteredFormList = (this.formApplayList || []).filter(item => item && (item.id || item.formName));
                return;
            }
            this.filteredFormList = (this.formApplayList || []).filter(item => {
                if (!item || !item.id || !item.formName) return false;
                return item.formName.includes(inputValue) || item.id.includes(inputValue);
            });
        },
        rowClick(record, index) {
            return {
                on: {
                    dblclick: () => {
                        if (record.fillStatus == 0 || record.fillStatus == 4) {
                            this.$router.push({
                                path: '/formReview/reviewCenter/processMain',
                                query: { item: JSON.stringify(record), type: record.fillStatus == 4 ? 4 : 1 }
                            });
                        } else {
                            this.$router.push({
                                path: '/formReview/reviewCenter/viewProcess',
                                query: { procInsId: record.processInstanceId, fillId: record.id, fillStatus: record.fillStatus }
                            });
                        }
                    }
                }
            };
        }
    },
    async mounted() {
        this.procInsId = this.$route.query && this.$route.query.procInsId;
        this.fillId = this.$route.query && this.$route.query.fillId;
        this.fillStatus = this.$route.query && this.$route.query.fillStatus;
        if (this.fillStatus == 3) this.printFlag = true;
        this.path = this.$route.query && this.$route.query.path;
        this.queryOrganPost();
        await this.onloadFlowRecord();
    }
};
</script>

<style lang="less" scoped>
.right-open {
    width: 500px;
    height: 100%;
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    animation: exampleRightOpen 0.5s ease-out;
}
.right-close {
    width: 0px;
    height: 100%;
    display: flex;
    overflow: hidden;
    animation: exampleRightClose 0.5s ease-in-out;
    white-space: nowrap;
}
.sliderbar-off {
    width: 40px;
    border-radius: 10px 0 0 10px;
    float: left;
    cursor: pointer;
    height: 120px;
    padding: 5px 10px;
    color: white;
    background-color: #1890ff;
}
/deep/ .ant-form-item {
    margin-bottom: 0px;
}
.process-view-container {
    display: flex;
    overflow-y: auto;
    .left-card {
        width: 100%;
        height: 100%;
        overflow-y: auto;
    }
    .right-card {
        flex: 1;
        margin-left: 10px;
        width: 35%;
        /deep/ .ant-card-body {
            height: 90%;
            overflow-y: scroll;
            .flow {
                height: 100%;
                padding-top: 10px;
                overflow-x: hidden;
                overflow-y: auto;
            }
        }
    }
    .a-tag {
        white-space: normal;
        height: auto;
        margin-top: 5px;
    }
    .label-font {
        color: #9c884f;
        font-weight: normal;
    }
    .div-class {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .noline {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
}
/deep/ .ant-cascader-picker-label {
    color: #000;
}
.noline {
    white-space: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
/deep/ .right-card .ant-card-body {
    height: calc(100vh - 200px);
    overflow-y: scroll;
}
.img {
    width: 120px;
    height: 100px;
    position: absolute;
    top: 5px;
    right: 30px;
    z-index: 99;
}
.zIndex-img {
    width: 120px;
    height: 100px;
    position: absolute;
    top: 5px;
    right: 30px;
}
.print-spin {
    position: fixed;
    top: 0;
    padding-top: 25%;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    text-align: center;
    z-index: 999;
}
/deep/ .el-popover__reference-wrapper {
    display: flex;
    flex-wrap: wrap;
}
.tab-header {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    background: #f5f5f5;
    border-radius: 4px 4px 0 0;
}
.tab-item {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    flex: 1;
    text-align: center;
    transition: all 0.3s;
    &:last-child { border-right: none; }
    &.active {
        background: #fff;
        color: #1890ff;
        font-weight: 500;
    }
    &:hover { color: #1890ff; }
}
.tab-content {
    height: calc(100% - 40px);
    overflow-y: auto;
    padding: 10px;
}
.modal-title-icons {
    float: right;
    font-size: 16px;
    i {
        margin-left: 16px;
        cursor: pointer;
        transition: color 0.3s;
        &:hover { color: #1890ff; }
    }
}
.process-modal-body {
    height: 60vh;
    min-height: 500px;
    /deep/ .process-tracker { height: 100%; }
    &.fullscreen-body { height: calc(100vh - 110px); }
}
/deep/ .fullscreen-modal {
    .ant-modal {
        top: 0;
        padding: 0;
        margin: 0;
        max-width: 100%;
        height: 100vh;
    }
    .ant-modal-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 0;
    }
    .ant-modal-header {
        flex-shrink: 0;
        border-radius: 0;
    }
    .ant-modal-body {
        flex: 1;
        overflow: hidden;
        padding: 16px;
    }
}
/deep/ .ant-table-wrapper {
    margin-top: 10px;
}
.multi-instance-group {
    .group-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
    }
    .group-detail {
        margin-top: 8px;
        border-top: 1px solid #eee;
        padding-top: 8px;
        .sub-task {
            margin-bottom: 8px;
        }
    }
}
</style>